// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

export const environment = {
    production: false,
    version: env['npm_package_version'] + '-dev',
    appName: env['npm_package_name'],
    author: env['npm_package_author'],
    description: env['npm_package_description'],
    serverUrl: '/api',
    defaultLanguage: 'es-ES',
    supportedLanguages: ['en-US', 'es-ES'],
    client_id: 'AVZ',
    fileApiKey: 'keyfilewwXHqY6ZnkFsrOGaoFigAnKeLdZ5gNDDRbcz6MBh6iGbkQAfHnQcH1HgF_dev',
    firebase: {
        apiKey: 'AIzaSyCb_138gbA0mlZbI1aK1CYXG1G1I8UBBNA',
        authDomain: 'comunidad-demo-app.firebaseapp.com',
        projectId: 'comunidad-demo-app',
        storageBucket: 'comunidad-demo-app.firebasestorage.app',
        messagingSenderId: '50970653654',
        appId: '1:50970653654:web:507a459db3a563f07a2a77',
        measurementId: 'G-YN16FFCRE2',
        vapidKey:
            'BAra038h097U6RqmIJnil3RPm35WUSeGAH53bPkUyFGYH3EH1ntCkZoEvB5lYd_YTV9Yf6ECbgSDNyIlllFA394',
    },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
